
<div *ngIf="content" [innerHTML]="content"></div>
<div *ngIf="notFound">Sorry, that eConnection couldn't be found.</div>